import { API_ROUTES } from '@/api/apiRoutes';
import { safeAxios } from '@/services/safeAxios';
import { CreditLimitWindowStatus, CreditLimitWindowsResponse } from './credits.api.types';

export const getCreditLimitWindowsApi = async (): Promise<CreditLimitWindowsResponse> => {
  // The server doesn't send the `type` discriminant; tag here so `CreditLimitStatus` consumers can narrow on it.
  const res = await safeAxios.get<{ windows: Omit<CreditLimitWindowStatus, 'type'>[] }>(
    API_ROUTES.credits.windowStatus(),
  );
  return {
    windows: res.data.windows.map((window): CreditLimitWindowStatus => ({ ...window, type: 'weave_credits' })),
  };
};
